export function ResidualWithBudget({ residual, errorBudget, unit = "", testId }) {
  const withinBudget = Math.abs(residual) <= errorBudget;
  const ratio = errorBudget ? Math.abs(residual) / errorBudget : 0;
  const markerPct = Math.max(2, Math.min(98, 50 + (residual / (errorBudget * 3 || 1)) * 48));

  return (
    <div className="space-y-2" data-testid={testId}>
      <div className="flex items-baseline justify-between font-mono-data">
        <div>
          <span className="text-[9px] uppercase text-[var(--oim-text-dim)] block">Residual</span>
          <span className="text-sm font-semibold text-[var(--oim-text)]">{residual >= 0 ? "+" : ""}{residual} {unit}</span>
        </div>
        <div className="text-right">
          <span className="text-[9px] uppercase text-[var(--oim-text-dim)] block">Error Budget</span>
          <span className="text-sm font-semibold text-[var(--oim-text-secondary)]">±{errorBudget} {unit}</span>
        </div>
      </div>
      <div className="relative h-2 rounded-full" style={{ backgroundColor: "var(--oim-surface-softer)" }}>
        <div className="absolute top-0 h-2 rounded-full" style={{ left: "33%", width: "34%", backgroundColor: "var(--oim-surface-soft)", border: "1px solid var(--oim-border)" }} />
        <div className="absolute top-1/2 -translate-y-1/2 w-2 h-2 rounded-full" style={{ left: `${markerPct}%`, backgroundColor: withinBudget ? "var(--oim-text-muted)" : "var(--oim-gold)" }} />
      </div>
      <div className="text-[10px] font-mono-data text-[var(--oim-text-dim)]">
        {withinBudget ? "WITHIN BUDGET — no finding raised" : `${ratio.toFixed(1)}× budget`}
      </div>
    </div>
  );
}
